import { useState, useEffect, useContext, useRef } from "react";
import { SideMenu } from "../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../components/data_table/data_table.component";
import OverLay from "../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { Badge, Dropdown, Label, Spinner, useId } from "@fluentui/react-components";
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Input, Card, Option, Tooltip, Image } from "@fluentui/react-components";
import { Info20Regular, LayerDiagonalPerson20Regular, BookTemplate20Regular, Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, Dismiss16Regular, PulseSquare20Regular, HomePerson20Regular, PersonCircle20Regular, AddSquare20Regular, Info20Filled, PanelLeftKey20Regular, ArrowDownload20Regular, Settings20Regular, ArrowUpload20Filled, Info16Filled } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../components/dropdown/menu.component";
import { DropdownComponent } from "../../components/dropdown/dropdown.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import FullScreenButton from "../../components/fullscreen/fullScreen.component";
import { GlobalContext } from "../../hooks/globalContext";
import { ToastComponent } from "../../components/toast/toast.component";
import { primaryIcon, lightTheme, overflowDivider, buttonContent, messageTheme, secondaryIcon, dividerWidthStyle, heightResponsive, parentHome, DynamicBoxingCSS, wraperStyle, timezoneInfo, SubSectionResponsive, dashboardTheme, BreadcrumbsBorder } from "../../styles/customStyles";
import { usePermissionStore, useTenantStore } from "../../Store/permissionStore";
import { SkeletonDataTable } from "../../components/skeleton/skeletonDataTable";
import { convertToLocalTimezone, convertUTCToReadableFormat, convertToExcelFormat } from "../../utility/utils";
import { SearchBar } from "../../components/searchbar/searchbar.component";
import { CustomWidgets } from "../../components/form-components";
import { Inputs } from "../../components/textarea/input.component";
import { Tenant_func } from "../../api/home/tenant_func";
import { CSVLink } from "react-csv";
import { DatepickerComponent } from "../../components/picker/datepicker.component";
import { InfoBar } from "../../components/infoBar/infoBar.component";
import { MultiselectWithTags } from "../../components/dropdown/multiselect.component";
import { AdministrationPages } from "../../components/side_menu/InlineSidenav";

export const Tenant = () => {
    const smallId = useId("input-small");
    const handle = useFullScreenHandle();
    const navigate = useNavigate();
    const formRef = useRef(null);
    const contextValue: any = useContext(GlobalContext);
    var tenantName = contextValue.tenantName;
    var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');
    const [final_data, set_final_data]: any = useState(null);
    const [tableData, setTableData] = useState([]);
    const [leftOpen, setLeftOpen] = useState(false);
    const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
    const [searchVal, setSearchVal] = useState("");
    const [totalPages, setTotalPages] = useState(1);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [exportData, setExportData] = useState([]);
    const [exportDetails, setExportDetails]: any = useState([]);
    const [refreshToast, setRefreshToast]: any = useState(false);
    const [isToast, setIsToast] = useState(false);
    const [isDynamicToast, setIsDynamicToast] = useState(false);
    const [isfilter, setIsFilter] = useState(false);
    const [isResetDisabled, setResetDisabled] = useState(true);
    const [filterMenuOpen, setFilterMenuOpen] = useState(false);
    const [filterArray, setFilterArray] = useState<string[]>([]);
    const [dropDownValue1, setDropDownValue1] = useState<any>();
    const [dropDownValue2, setDropDownValue2] = useState<any>();
    const [dropDownValueWin64, setDropDownValueWin64] = useState<any>();
    const [dropDownValueAndroidApk, setDropDownValueAndroidApk] = useState<any>();
    const [dropDownValueMACVersion, setDropDownValueMACVersion] = useState<any>();
    const [dropDownValueMACIntel, setDropDownValueMACIntel] = useState<any>();
    const [dropDownValueWindowsVersion, setDropDownValueWindowsVersion] = useState<any>();
    const [dropDownValueAndroidVersion, setDropDownValueAndroidVersion] = useState<any>();
    const [dropDownValueIosVersion, setDropDownValueIosVersion] = useState<any>();
    const [spinnerLoad, setSpinnerLoad] = useState(true);
    const { setTenant } = useTenantStore();
    const [date, isDate]: any = useState();
    const [module, isModule]: any = useState();
    const [initiated, isInitiated]: any = useState();
    const [action, isAction]: any = useState();
    const [status, isStatus]: any = useState();
    const [activityExportData, setActivityExportData] = useState<any>('No data available');
    const { permissions } = usePermissionStore();
    const [loading, setLoading] = useState(true);
    const [overlayData, setOverlayData] = useState<any>(false);
    const [activity, setActivity]: any = useState('{}');
    const [uischema, setUischema] = useState({});
    const [tenantOverLayData, setTenantOverLayData]: any = useState([]);
    const [dropdownData, setDropdownData] = useState(null);
    const [rowID, setRowID]: any = useState(null);
    const [overlayName, setOverlayName] = useState('');
    const [overlayOpen, setOverlayOpen] = useState(false);
    const [OverLayData, setOverLayData]: any = useState([]);
    const [jsonSchema, setJsonData]: any = useState({});
    const [uiSchema, setUiData]: any = useState({});
    const [formData, setFormData]: any = useState({
        tenant: '',
        "client_32_name": '',
        "client_64_name": '',
        "androidClient": '',
        "macVersion": '',
        "macIntel": '',
        "windowsVersion": "",
        "androidVersion": "",
        "iosVersion": "",
    });
    const [formEditData, setFormEditData]: any = useState({
        tenant: '',
        "client_32_name": '',
        "client_64_name": '',
        "androidClient": '',
        "macVersion": '',
        "macIntel": '',
    });
    const [errorToast, setErrorToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [saveBtnClicked, setSaveBtnClicked]: any = useState(false);
    const [saveTriggered, setSaveTriggered]: any = useState(false);
    const [exportBtnClicked, setExportBtnClicked] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState<any[]>([]);
    const [selectedTenant, setSelectedTenant] = useState('');
    const [clientExecutableFiles, setClientExecutableFiles] = useState([]);

    const [isRefresh, setIsRefresh]: any = useState(false);
    const [clientList, setClientList] = useState<any>([]);
    const [clientVersionsList, setClientVersionsList] = useState<any>([]);
    const [dropDownValue, setDropDownValue] = useState<any>();
    const [dropDownData64, setDropDownData64] = useState<any>();
    const [selectedValue, setSelectedValue] = useState(0);
    const [dropDownDataAndroidApk, setDropDownDataAndroidApk] = useState<any>([]);
    const [dropDownDataMacVersion, setDropDownDataMacVersion] = useState<any>([]);
    const [dropDownDataMacIntel, setDropDownDataMacIntel] = useState<any>([]);
    const [dropDownDataWindowsVersion, setDropDownDataWindowsVersion] = useState<any>([]);
    const [dropDownDataAndroidVersion, setDropDownDataAndroidVersion] = useState<any>([]);
    const [dropDownDataIosVersion, setDropDownDataIosVersion] = useState<any>([]);
    const [uniqueWindowsVersionData, setUniqueWindowsVersionData] = useState<any>([]);
    const [uniqueAndroidVersionData, setUniqueAndroidVersionData] = useState<any>([]);
    const [uniqueIosVersionData, setUniqueIosVersionData] = useState<any>([]);

    const [siteName, setSiteName] = useState('');
    const [licenseDetails, setLicenseDetails] = useState({
        totalCnt: 0,
        usedCnt: 0,
    });
    const [downloadURL, setDownloadURL] = useState('');
    const [downloadFileName, setDownloadFileName] = useState('');
    const [tableColumnsData, setTableColumnsData] = useState([]);
    const [filterColumnsData, setFilterColumnsData] = useState([]);
    const [copied, setCopied] = useState(false);
    const [errorMessage, setErrorMessage] = useState<String>('')
    const [uniqueCreatedBy, setUniqueCreatedBy] = useState<string[]>([]);
    const [isCreatedBy, setCreatedBy] = useState<any[]>([]);
    const [message, setMessage] = useState<{ type: 'success' | 'error' | 'warning'; text: string } | null>(null);

    useEffect(() => {
        const createdByOptions = uniqueCreatedBy.map((item) => {
            return { key: item, label: <Caption1>{item}</Caption1>, };
        });
        setCreatedBy(createdByOptions);
        console.log("Created By Options:", createdByOptions);
    }, [uniqueCreatedBy]);
    // const [editTenantDetails, setEditTenantDetails] = useState(false)

    const iconStyleProps: any = {
        primaryFill: "#008099",
        className: "iconClass",
    };
    console.log("checking the permissions------>", permissions);

    const handleFilterArray = (): any => {
        const value1 = dropDownValue1;
        const value2 = dropDownValue2;
        const result = value1 + " : " + value2;
        setFilterArray([...filterArray, result])
        setIsFilter(true);
        setLoading(true);
        setDropDownValue1('');
        setDropDownValue2('');
    }

    const handleUserSearchInput = (e: any, type = '') => {
        const val = e.target.value;

        if (type === "windows") {
            const newArr = uniqueWindowsVersionData.filter((item) => item.includes(val));

            if (val === "") {
                setDropDownDataWindowsVersion(uniqueWindowsVersionData);
            } else if (!(/^[\d.]+$/.test(val))) {
                return false;
            } else if (newArr.length === 0) {
                setDropDownDataWindowsVersion([val]);
            } else {
                setDropDownDataWindowsVersion(newArr);
            }

        } else if (type === "android") {
            const newArr = uniqueAndroidVersionData.filter((item) => item.includes(val));

            if (val === "") {
                setDropDownDataAndroidVersion(uniqueAndroidVersionData);
            } else if (!(/^[\d.]+$/.test(val))) {
                return false;
            } else if (newArr.length === 0) {
                setDropDownDataAndroidVersion([val]);
            } else {
                setDropDownDataAndroidVersion(newArr);
            }
        } else if (type === "ios") {
            const newArr = uniqueIosVersionData.filter((item) => item.includes(val));

            if (val === "") {
                setDropDownDataIosVersion(uniqueIosVersionData);
            } else if (!(/^[\d.]+$/.test(val))) {
                return false;
            } else if (newArr.length === 0) {
                setDropDownDataIosVersion([val]);
            } else {
                setDropDownDataIosVersion(newArr);
            }
        }
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(downloadURL).then(() => {
            console.log("flow coming here");
            setCopied(true);
            setTimeout(() => setCopied(false), 4000);
        });
    }

    const handleCloseFilter = (index: any): any => {
        const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
        setFilterArray(updatedArray);
        setLoading(true);
    }
    const inputChange = (e: any) => {
        const enteredValue = e.target.value;
        let name = e.target.name;
        const regexS = /^[A-Za-z ]*$/;
        const regexSN = /^[A-Za-z0-9-_ ]*$/;
        const regexN = /^[0-9]*$/;
        if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1} :`))) {
            setErrorMessage(`${dropDownValue1} is already filtered.`);
            return;
        } else {
            setErrorMessage(''); // Clear the message if no issue
        }
        if (name === 'filter' && dropDownValue1 === ('Tenant Name')) {
            if (regexSN.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
    }

    useEffect(() => {
        if (filterArray.length > 0) {
            setResetDisabled(false)
        }
        else {
            setResetDisabled(true)
        }
    }, [filterArray])

    const handleNewTenantClick = () => {
        setOverlayOpen(true);
        setOverlayName('addTenant');
         setSpinnerLoad(false);
        setFormData({
            ...formData,
            tenant: '',
            "client_32_name": '',
            "client_64_name": '',
            "androidClient": '',
            "macVersion": '',
            "macIntel": '',
            "windowsVersion": '',
            "androidVersion": '',
            "iosVersion": '',
        });

        setDropDownValue('');
        setDropDownValueWin64('');
        setDropDownValueAndroidApk('');
        setDropDownValueMACVersion('');
        setDropDownValueMACIntel('');

        setDropDownValueWindowsVersion('');
        setDropDownValueAndroidVersion('');
        setDropDownValueIosVersion('');
    };

    useEffect(() => {
        var flag = true;
        exportDetails.map((val: any) => {
            if (val.sitename === formData.tenant) {
                flag = false;
            }
        });

        if (overlayName === 'editTenant' && formData.tenant === selectedTenant) {
            flag = true;
        }

        // setClassificationNameValidation(flag);
    }, [formData, selectedTenant]);

    const saveBtnFunc = () => {
        if (formData === null || Object.values(formData).some(val => val === '')) {
            alert("Please fill in all fields");
        } else {
            if (overlayName === 'editTenant') {
                // Handle editing logic
                console.log('Editing tenant:', formEditData);
                setFormEditData(formData);
            } else {
                // Handle adding logic
                console.log('Adding tenant:', formData);
                // Save logic for new tenant
            }
            setOverlayOpen(false);
        }
    }

    useEffect(() => {
        if (!saveBtnClicked) {
            // setOverlayOpen(false);
            setFormData({
                tenant: '',
                "client_32_name": '',
                "client_64_name": '',
                "androidClient": '',
                "macVersion": '',
                "macIntel": '',
                "windowsVersion": '',
                "androidVersion": '',
                "iosVersion": '',
            });
            setFormEditData({ name: '', description: '', jsonData: '', category: [], subCategory: [] });

            setDropDownValueWindowsVersion('');
            setDropDownValueAndroidVersion('');
            setDropDownValueIosVersion('');
        }
    }, [saveBtnClicked]);

    useEffect(() => {
        // Loading client_32_name into dropdown data

        const clientDropDownDataObj32 = [];
        const clientDropDownDataObj64 = [];
        const clientDropDownDataObjApk = [];
        const clientDropDownDataObjMacVersion = [];
        const clientDropDownDataObjMacIntel = [];

        // const clientDropDownDataObjWindowsVersion = [];
        // const clientDropDownDataObjAndroidVersion = [];
        // const clientDropDownDataObjIosVersion = [];

        clientList.forEach((val: any, i: number) => {
            // val?.client_32_name?.length > 0 && clientDropDownDataObj32.push(
            //     {
            //         key: `client_${i + 1}`,
            //         label: (
            //         <Body1 onClick={() => { 
            //             setSelectedValue(parseInt(val.siteid));
            //             // Handle selection of client_32_name here
            //             }}>
            //             {val.client_32_name}
            //         </Body1>
            //         ),
            //     }
            // );

            // val?.client_64_name?.length > 0 && clientDropDownDataObj64.push(
            //     {
            //         key: `client_${i + 1}`,
            //         label: (
            //             <Body1 onClick={() => { 
            //                 setSelectedValue(parseInt(val.siteid));
            //                 // Handle selection of client_32_name here
            //                 }}>
            //                 {val.client_64_name}
            //             </Body1>
            //         ),
            //     }
            // );

            val?.client_android_name?.length > 0 && clientDropDownDataObjApk.push(
                {
                    key: `client_${i + 1}`,
                    label: (
                        <Body1 onClick={() => {
                            // setSelectedValue(parseInt(val.siteid));
                            // Handle selection of client_32_name here
                        }}>
                            {val.client_android_name}
                        </Body1>
                    ),
                }
            );

            val?.client_mac_name?.length > 0 && clientDropDownDataObjMacVersion.push(
                {
                    key: `client_${i + 1}`,
                    label: (
                        <Body1 onClick={() => {
                            setSelectedValue(parseInt(val.siteid));
                            // Handle selection of client_32_name here
                        }}>
                            {val.client_mac_name}
                        </Body1>
                    ),
                }
            );

            // val?.client_mac_intel?.length > 0 && clientDropDownDataObjMacIntel.push(
            //     {
            //         key: `client_${i + 1}`,
            //         label: (
            //             <Body1 onClick={() => { 
            //                 setSelectedValue(parseInt(val.siteid));
            //                 // Handle selection of client_32_name here
            //                 }}>
            //                 {val.client_mac_intel}
            //             </Body1>
            //         ),
            //     }
            // );
        });

        // setDropdownData(clientDropDownDataObj32);
        // setDropDownData64(clientDropDownDataObj64);
        setDropDownDataAndroidApk(clientDropDownDataObjApk);
        setDropDownDataMacVersion(clientDropDownDataObjMacVersion);
        setDropDownDataMacIntel(clientDropDownDataObjMacIntel);
    }, [clientList]);

    useEffect(() => {
        const uniqueWindowsVersionData = clientVersionsList.filter((item, index) => clientVersionsList.indexOf(item) === index);

        const uniqueAndroidVersionData = clientVersionsList.filter((item, index) => clientVersionsList.indexOf(item) === index);

        const uniqueIosVersionData = clientVersionsList.filter((item, index) => clientVersionsList.indexOf(item) === index);

        setDropDownDataWindowsVersion(uniqueWindowsVersionData);
        setUniqueWindowsVersionData(uniqueWindowsVersionData);

        setDropDownDataAndroidVersion(uniqueAndroidVersionData);
        setUniqueAndroidVersionData(uniqueAndroidVersionData);

        setDropDownDataIosVersion(uniqueIosVersionData);
        setUniqueIosVersionData(uniqueIosVersionData);
    }, [clientVersionsList]);

    useEffect(() => {
        const clientDropDownDataObj32 = [];
        const clientDropDownDataObj64 = [];

        clientExecutableFiles.forEach((val: any, i: number) => {
            if (val.toLocaleLowerCase().includes("32bit") || (val.includes("32") && !val.includes("64"))) {
                clientDropDownDataObj32.push(
                    {
                        key: `client_${i + 1}`,
                        label: (
                            <Body1>
                                {val}
                            </Body1>
                        ),
                    }
                );
            }

            if (val.toLocaleLowerCase().includes("64bit") || (val.includes("64") && !val.includes("32"))) {
                clientDropDownDataObj64.push(
                    {
                        key: `client_${i + 1}`,
                        label: (
                            <Body1>
                                {val}
                            </Body1>
                        ),
                    }
                );
            }

            setDropdownData(clientDropDownDataObj32);
            setDropDownData64(clientDropDownDataObj64);
        });
    }, [clientExecutableFiles]);

    //data table column name code starts here
    // var columns = [
    //     { key: "tenant_name", label: <Body1Strong> Tenant Name </Body1Strong> },
    //     { key: "createdOn", label: <Body1Strong> Created On (UTC) </Body1Strong> },
    //     { key: "createdOn_timezoned", label: <Body1Strong> Created On ({formattedTimeZone}) </Body1Strong> },
    //     { key: "modifed_on", label: <Body1Strong> Modified On (UTC)</Body1Strong> },
    //     { key: "modifed_on_timezoned", label: <Body1Strong> Modified On ({formattedTimeZone}) </Body1Strong> },
    //     { key: "createdBy", label: <Body1Strong> Created By </Body1Strong> },
    // ];
    //data table column name code ends here

    //data table for filter column
    // var columns1 = [
    //     { key: "tenant_name", label: <Caption1> Tenant Name </Caption1> },
    //     { key: "createdOn", label: <Caption1> Created On </Caption1> },
    //     { key: "modifed_on", label: <Caption1> Modified On</Caption1> },
    //     { key: "createdBy", label: <Caption1> Created By </Caption1> },
    // ];

    // overflow set contents code starts here
    var overFlowComponent = {
        data:
            <>
                <StackItem>
                    <Button disabled={loading} shape="circular" appearance="subtle" size="small" onClick={() => { handleNewTenantClick(); }}>
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem> <AddSquare20Regular {...(loading?secondaryIcon:primaryIcon)} /> </StackItem>
                            <StackItem> <Caption1> Create Tenant </Caption1> </StackItem>
                        </Stack>
                    </Button>
                </StackItem>

                <StackItem>
                    <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setIsRefresh(true); setLoading(true) }}>
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
                            <StackItem> <Caption1> Refresh </Caption1> </StackItem>
                        </Stack>
                    </Button>
                </StackItem>

                {permissions.includes("all") || permissions.includes("tenant_ReadandExport") || permissions.includes("tenant_Fullaccess") ?
                    <StackItem>
                        <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_Tenant_assignmentlist.csv`}>
                        </CSVLink>
                        <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true); }}>
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                                <StackItem> <Caption1> Export </Caption1> </StackItem>
                            </Stack>
                        </Button>
                    </StackItem>
                    :
                    <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                        <Button shape="circular" appearance="subtle" size="small" disabled>
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                <StackItem><Text></Text></StackItem>
                                <StackItem>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                                        <StackItem><Caption1>  Export </Caption1></StackItem>
                                    </Stack>
                                </StackItem>
                            </Stack>
                        </Button>
                    </Tooltip>
                }
                <StackItem>
                    <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />}  </StackItem>
                            <StackItem> <Caption1> Manage View </Caption1> </StackItem>
                        </Stack>
                    </Button>
                </StackItem>

                <StackItem grow shrink>
                    <Stack horizontalAlign="end">
                        <StackItem grow shrink>
                            <FullScreenButton handle={handle} />
                        </StackItem>
                    </Stack>
                </StackItem>
            </>
        ,
    };
    // overflow set contents code ends here
    var tableColumns: any[] = [];
    var filterColumns: any[] = [];
    useEffect(() => {
        contextValue?.tableColumnsData?.Administration?.Tenant.forEach((val) => {
            if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
                if (val.key === "createdOn_timezoned" || val.key === "modifed_on_timezoned") {
                    tableColumns[val.priority] = ({
                        key: val.key,
                        label:
                            <>
                                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                                    <StackItem>
                                        <Body1Strong>{`${val.name}`}</Body1Strong>
                                    </StackItem>
                                    <StackItem align="center">
                                        <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                                            <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                                        </Tooltip>
                                    </StackItem>
                                </Stack>
                            </>
                    });
                } else {
                    tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
                }
            }

            if (val.display.filter.toLocaleLowerCase() === "yes") {
                filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
            }
        });

        setTableColumnsData(tableColumns);
        setFilterColumnsData(filterColumns);

        contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Administration?.Tenant.filter((val) => val.priority >= 0));

        contextValue.setManageViewPageDetails({ module: "Administration", page: "Tenant" });
    }, [contextValue.tableColumnsData]);

    var tempTableData: any = [];
    const buttonref: any = useRef(null);
    const handleOutsideButton = () => {
        buttonref?.current?.click();
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
    }

    useEffect(() => {
        var tempExportData: any = [];
        exportDetails?.length > 0 && exportDetails.map((val: any) => {
            tempExportData.push({
                'id': val.siteid,
                'Site Name': val.sitename,
                'Created On': convertToExcelFormat(val.firstcontact),
                'Modified On': convertToExcelFormat(val.lastcontact),
                'Created By': val.username
            });
        });
        setExportData(tempExportData);
    }, [exportDetails]);

    useEffect(() => {
        if (final_data !== undefined && final_data !== null) {
            const newUniqueCreatedBy: string[] = [];

            final_data?.forEach((val: any) => {
                if (val.username && val.username.trim() !== "-" && !newUniqueCreatedBy.includes(val.username)) {
                    newUniqueCreatedBy.push(val.username);
                }
            });

            setUniqueCreatedBy(newUniqueCreatedBy);
            console.log("Unique Created By:", newUniqueCreatedBy);
        } else {
            setUniqueCreatedBy([]);
        }
    }, [final_data]);

    useEffect(() => {
        // data table values append code starts here
        console.log("final_data=", final_data);
        // const sortedData = final_data !== undefined && final_data !== null
        //     ? final_data.sort((a: any, b: any) => {
        //         const nameA = a.sitename.toLowerCase(); // Convert to lowercase for case-insensitive comparison
        //         const nameB = b.sitename.toLowerCase();
        //         if (nameA < nameB) return -1;
        //         if (nameA > nameB) return 1;
        //         return 0; // If names are the same
        //     })
        //     : [];

        final_data !== undefined && final_data !== null
            ? final_data.map((val: any, i: any) => {
                {
                    permissions.includes("all") || permissions.includes("tenant_Fullaccess") ?
                        tempTableData.push({
                            id: val.siteid,
                            checkbox: 'hide',
                            tenant_name: { label: <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={() => { setOverlayOpen(true); setOverlayName('editTenant'); setRowID(val.siteid); setSiteName(val.sitename); setSpinnerLoad(true) }}> {val.sitename} </Button>, id: `${i}` },
                            createdOn: { label: <Caption1> {(val.firstcontact !== null && val.firstcontact !== " ") ? convertUTCToReadableFormat(val.firstcontact) : "-"} </Caption1> },
                            createdOn_timezoned: { label: <Caption1> {(val.firstcontact !== null && val.firstcontact !== " ") ? convertToLocalTimezone(val.firstcontact, userTimeZone) : "-"} </Caption1> },
                            modifed_on: { label: <Caption1> {(val.lastcontact !== null && val.lastcontact !== " " && val.lastcontact != 0) ? convertUTCToReadableFormat(val.lastcontact) : "-"} </Caption1> },
                            modifed_on_timezoned: { label: <Caption1> {(val.lastcontact !== null && val.lastcontact !== " " && val.lastcontact != 0) ? convertToLocalTimezone(val.lastcontact, userTimeZone) : "-"} </Caption1> },
                            createdBy: { label: <Caption1> {val.username} </Caption1> },
                        })
                        :
                        tempTableData.push({
                            id: val.siteid,
                            checkbox: 'hide',
                            tenant_name: {
                                label:
                                    <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                                        <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small"> {val.sitename} </Button>
                                    </Tooltip>, icon: "", id: `${i}`
                            },
                            createdOn: { label: <Caption1> {(val.firstcontact !== null && val.firstcontact !== " ") ? convertUTCToReadableFormat(val.firstcontact) : "-"} </Caption1> },
                            createdOn_timezoned: { label: <Caption1> {(val.firstcontact !== null && val.firstcontact !== " ") ? convertToLocalTimezone(val.firstcontact, userTimeZone) : "-"} </Caption1> },
                            modifed_on: { label: <Caption1> {(val.lastcontact !== null && val.lastcontact !== " " && val.lastcontact != 0) ? convertUTCToReadableFormat(val.lastcontact) : "-"} </Caption1> },
                            modifed_on_timezoned: { label: <Caption1> {(val.lastcontact !== null && val.lastcontact !== " " && val.lastcontact != 0) ? convertToLocalTimezone(val.lastcontact, userTimeZone) : "-"} </Caption1> },
                            createdBy: { label: <Caption1> {val.username} </Caption1> },
                        })
                }
            }) : (tempTableData = []);
        tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
        setTimeout(() => {
            final_data !== undefined && final_data !== null && setLoading(false);
        }, 500);
    }, [final_data, permissions]);
    // data table ,values append code ends here
    useEffect(() => {
        exportData.length > 0 && document.getElementById('csv-export-link')?.click();
    }, [exportData]);

    useEffect(() => {
        setFormData({
            ...formData,
            [`client_32_name`]: dropDownValue,
            [`client_64_name`]: dropDownValueWin64,
            androidClient: dropDownValueAndroidApk,
            macVersion: dropDownValueMACVersion,
            macIntel: dropDownValueMACIntel,
            windowsVersion: dropDownValueWindowsVersion,
            androidVersion: dropDownValueAndroidVersion,
            iosVersion: dropDownValueIosVersion,
        });
    }, [dropDownValue, dropDownValueWin64, dropDownValueAndroidApk, dropDownValueMACVersion, dropDownValueMACIntel, dropDownValueWindowsVersion, dropDownValueAndroidVersion, dropDownValueIosVersion]);

    const handleClientDownloadBtn = async (downloadLink: string, name: string) => {
        const response = await fetch(downloadLink);
        const blob = await response.blob(); // Get the file as a Blob
        console.log('Blob size:', blob.size); // Check if it's 0KB

        // Create a link element and use Blob URL
        const link = document.createElement('a');
        const blobUrl = URL.createObjectURL(blob);
        link.href = blobUrl;

        // Set the custom file name
        link.setAttribute('download', name);

        // Append to the document and trigger download
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
    }

    //overlay code starts here
    useEffect(() => {
        console.log("formData[`client_32_name`]=", formData[`client_32_name`]);
        console.log("overlayName=", overlayName);
        console.log("formData=", formData);

        // Set overlay data based on overlay name (add or edit tenant)

        if (overlayName === 'addTenant') {
            setTenantOverLayData({
                headerTitle: "Create Tenant",
                size: "large",
                isTabs: true,
                tabItems: {
                    "Create Tenant": (
                        <form id="myFormAppmonitored" onSubmit={handleSubmit} autoComplete="off">
                            <>
                                <Stack tokens={{ childrenGap: 10, padding: "10px 0px" }}>
                                    <InfoBar title={"These details will make it easy to find snippet later when you need to use them."} />
                                    {/* Tenant Name Input */}
                                    <Stack tokens={{ childrenGap: 15 }}>
                                        <StackItem>
                                            <Body1Strong>Tenant Name <Image src="/Dashboard/image/required.svg" /></Body1Strong>
                                        </StackItem>
                                        <StackItem>
                                            <Stack>
                                                <Label size="small" htmlFor={smallId}>
                                                </Label>
                                                <Input value={formData.tenant} onChange={(e: any) => { setFormData({ ...formData, tenant: e.target.value }) }} required />
                                            </Stack>
                                        </StackItem>
                                    </Stack>

                                    {/* 32-bit Client Executable Dropdown */}
                                    <Stack tokens={{ childrenGap: 15 }}>
                                        <StackItem>
                                            <Body1Strong>Windows 32-bit client executable <Image src="/Dashboard/image/required.svg" /></Body1Strong>
                                        </StackItem>
                                        <StackItem>
                                            <DropdownComponent optionData={dropdownData} setDropDownValue={setDropDownValue} dropDownvalue={dropDownValue} defaultSelected={formData[`client_32_name`]} placeholder="Select Windows 32-bit client executable" required={true} />
                                        </StackItem>
                                    </Stack>

                                    {/* 64-bit Client Executable Dropdown */}
                                    <Stack tokens={{ childrenGap: 15 }}>
                                        <StackItem>
                                            <Body1Strong>Windows 64-bit client executable<Image src="/Dashboard/image/required.svg" /> </Body1Strong>
                                        </StackItem>
                                        <StackItem>
                                            <DropdownComponent optionData={dropDownData64} setDropDownValue={setDropDownValueWin64} dropDownvalue={dropDownValueWin64} defaultSelected={formData[`client_64_name`]} placeholder="Select Windows 64-bit client executable" required={true} />
                                        </StackItem>
                                    </Stack>
                                    <Stack tokens={{ childrenGap: 15 }}>
                                        <StackItem>
                                            <Body1Strong>Windows version number<Image src="/Dashboard/image/required.svg" /> </Body1Strong>
                                        </StackItem>
                                        <StackItem>
                                            <MultiselectWithTags onChange={(e: any) => handleUserSearchInput(e, 'windows')}
                                                options={dropDownDataWindowsVersion}
                                                setSelectedOptions={setDropDownValueWindowsVersion}
                                                selectedOptions={[dropDownValueWindowsVersion]} multi={false} tag={true} placeholder="Select Windows client version" />
                                        </StackItem>
                                    </Stack>

                                    {/* Android Client APK Dropdown */}
                                    <Stack tokens={{ childrenGap: 15 }}>
                                        <StackItem>
                                            <Body1Strong>Android client APK </Body1Strong>
                                        </StackItem>
                                        <StackItem>
                                            {/* <Dropdown placeholder="Select Android client APK" /> */}
                                            <DropdownComponent optionData={dropDownDataAndroidApk} setDropDownValue={setDropDownValueAndroidApk} dropDownvalue={dropDownValueAndroidApk} placeholder="Select Android client APK" defaultSelected={formData.androidClient} />
                                        </StackItem>
                                    </Stack>
                                    <Stack tokens={{ childrenGap: 15 }}>
                                        <StackItem>
                                            <Body1Strong>Android version number</Body1Strong>
                                        </StackItem>
                                        <StackItem>
                                            <MultiselectWithTags onChange={(e: any) => handleUserSearchInput(e, 'android')} options={dropDownDataAndroidVersion} setSelectedOptions={setDropDownValueAndroidVersion} selectedOptions={[dropDownValueAndroidVersion]} multi={false} tag={true} placeholder="Select Android client version" />
                                        </StackItem>
                                    </Stack>

                                    {/* MAC Versions Dropdown */}
                                    <Stack tokens={{ childrenGap: 15 }}>
                                        <StackItem>
                                            <Body1Strong>MAC (M1, M2, M3) </Body1Strong>
                                        </StackItem>
                                        <StackItem>
                                            <DropdownComponent optionData={dropDownDataMacVersion} setDropDownValue={setDropDownValueMACVersion} dropDownvalue={dropDownValueMACVersion} placeholder="Select MAC version" defaultSelected={formData.macVersion} />

                                            {/* <Dropdown placeholder="Select MAC version" /> */}
                                        </StackItem>
                                    </Stack>

                                    {/* MAC Intel Dropdown */}
                                    <Stack tokens={{ childrenGap: 15 }}>
                                        <StackItem>
                                            <Body1Strong>MAC (Intel) </Body1Strong>
                                        </StackItem>
                                        <StackItem>
                                            <DropdownComponent optionData={dropDownDataMacIntel} setDropDownValue={setDropDownValueMACIntel} dropDownvalue={dropDownValueMACIntel} placeholder="Select MAC (Intel)" defaultSelected={formData.macIntel} />
                                            {/* <Dropdown placeholder="Select MAC (Intel)" /> */}
                                        </StackItem>
                                    </Stack>
                                    <Stack tokens={{ childrenGap: 15 }}>
                                        <StackItem>
                                            <Body1Strong>Mac version number</Body1Strong>
                                        </StackItem>
                                        <StackItem>
                                            <MultiselectWithTags onChange={(e: any) => handleUserSearchInput(e, 'ios')} options={dropDownDataIosVersion} setSelectedOptions={setDropDownValueIosVersion} selectedOptions={[dropDownValueIosVersion]} multi={false} tag={true} placeholder="Select MAC client version" />
                                        </StackItem>
                                    </Stack>

                                </Stack>
                                <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
                            </>
                        </form>
                    ),

                    "Review Data": (
                        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
                            <InfoBar title={"These details will make it easy to find snippet later when you need to use them."} />
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong> Tenant Name </Body1Strong>
                                </StackItem>
                                <StackItem>
                                    <Stack>
                                        <Label size="small" htmlFor={smallId}>
                                        </Label>
                                        <Input size="small" value={formData.tenant} id="0" maxLength={50} disabled={true} />
                                    </Stack>
                                </StackItem>
                            </Stack>

                            {/* 32-bit Client Executable Dropdown */}
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong>Windows 32-bit client executable </Body1Strong>
                                </StackItem>
                                <StackItem>
                                    {/* <DropdownComponent optionData={dropdownData} setDropDownValue={setDropDownValue} dropDownValue={formData[`client_32_name`]} defaultValue={formData[`client_32_name`]} defaultSelected={formData[`client_32_name`]} placeholder="Select Windows 32-bit client executable" disabled={true} /> */}
                                    {formData[`client_32_name`].length > 0 ? <Badge color="informative">{formData[`client_32_name`]}</Badge> : 'Not Selected'}
                                </StackItem>
                            </Stack>

                            {/* 64-bit Client Executable Dropdown */}
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong>Windows 64-bit client executable </Body1Strong>
                                </StackItem>
                                <StackItem>
                                    {/* <DropdownComponent optionData={dropDownData64} setDropDownValue={setDropDownValueWin64} dropDownvalue={dropDownValueWin64} placeholder="Select Windows 64-bit client executable" defaultSelected={formData[`client_64_name`]} disabled={true} /> */}
                                    {formData[`client_64_name`].length > 0 ? <Badge color="informative">{formData[`client_64_name`]}</Badge> : 'Not Selected'}
                                </StackItem>
                            </Stack>
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong>Windows version number </Body1Strong>
                                </StackItem>
                                <StackItem>
                                    {formData.windowsVersion?.length > 0 ? <Badge color="informative">{formData.windowsVersion}</Badge> : 'Not Selected'}
                                </StackItem>
                            </Stack>

                            {/* Android Client APK Dropdown */}
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong>Android client APK </Body1Strong>
                                </StackItem>
                                <StackItem>
                                    {/* <DropdownComponent optionData={dropDownDataAndroidApk} setDropDownValue={setDropDownValueAndroidApk} dropDownvalue={dropDownValueAndroidApk} placeholder="Select Android client APK" defaultSelected={formData.androidClient} disabled={true} /> */}
                                    {formData.androidClient.length > 0 ? <Badge color="informative">{formData.androidClient}</Badge> : 'Not Selected'}
                                </StackItem>
                            </Stack>
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong>Android version number </Body1Strong>
                                </StackItem>
                                <StackItem>
                                    {formData.androidVersion?.length > 0 ? <Badge color="informative">{formData.androidVersion}</Badge> : 'Not Selected'}
                                </StackItem>
                            </Stack>

                            {/* MAC Versions Dropdown */}
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong>MAC (M1, M2, M3) </Body1Strong>
                                </StackItem>
                                <StackItem>
                                    {/* <DropdownComponent optionData={dropDownDataMacVersion} setDropDownValue={setDropDownValueMACVersion} dropDownvalue={dropDownValueMACVersion} placeholder="Select MAC version" defaultSelected={formData.macVersion} disabled={true} /> */}
                                    {formData.macVersion.length > 0 ? <Badge color="informative">{formData.macVersion}</Badge> : 'Not Selected'}
                                </StackItem>
                            </Stack>

                            {/* MAC Intel Dropdown */}
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong>MAC (Intel) </Body1Strong>
                                </StackItem>
                                <StackItem>
                                    {/* <DropdownComponent optionData={dropDownDataMacIntel} setDropDownValue={setDropDownValueMACVersion} dropDownvalue={dropDownValueMACIntel} placeholder="Select MAC version" defaultSelected={formData.macIntel} disabled={true} /> */}
                                    {formData.macIntel.length > 0 ? <Badge color="informative">{formData.macIntel}</Badge> : 'Not Selected'}
                                </StackItem>
                            </Stack>
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong>MAC version number</Body1Strong>
                                </StackItem>
                                <StackItem>
                                    {formData.iosVersion?.length > 0 ? <Badge color="informative">{formData.iosVersion}</Badge> : 'Not Selected'}
                                </StackItem>
                            </Stack>
                        </Stack>
                    ),
                },
            });
        } else if (overlayName === 'editTenant') {
            console.log("overlayName=", overlayName);
            console.log("formData=", formData);

            setTenantOverLayData({
                headerTitle: `Edit ${siteName} tenant`,
                size: "large",
                isTabs: true,
                tabItems: {
                    "License Details": (
                        spinnerLoad ?
                            <Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
                                <Spinner />
                            </Stack> :
                            <form id="myFormAppmonitored" onSubmit={handleSubmit}>
                                <FluentProvider theme={dashboardTheme}>
                                    <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
                                        <Stack horizontal tokens={{ childrenGap: 100 }}>
                                            <StackItem>
                                                <Stack tokens={{ childrenGap: 15 }}>
                                                <StackItem> <Body1>Total Licenses Allocated</Body1></StackItem>
                                                <StackItem> <Body1>Licenses Available</Body1></StackItem>
                                                <StackItem> <Body1>Licenses In Use</Body1></StackItem>
                                                <StackItem><Body1> Nanoheal Client Setup </Body1></StackItem>
                                            </Stack>
                                        </StackItem>
                                        <StackItem>
                                            <Stack tokens={{ childrenGap: 15 }}>
                                                <StackItem>{licenseDetails.totalCnt}</StackItem>
                                                <StackItem>{licenseDetails.totalCnt - licenseDetails.usedCnt}</StackItem>
                                                <StackItem>{licenseDetails.usedCnt}</StackItem>
                                                <StackItem>
                                                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                                                        <StackItem>
                                                            <Button shape="circular" appearance="primary" size="small" onClick={(e) => handleClientDownloadBtn(downloadURL, downloadFileName)}>  Download</Button>
                                                        </StackItem>
                                                        <StackItem>
                                                            {/* <Button shape="circular" appearance="primary" size="small" onClick={handleCopy}  >  {copied ? "Copied" : "Copy Link"}  </Button> */}
                                                        </StackItem>
                                                    </Stack>
                                                </StackItem>
                                            </Stack>
                                        </StackItem>
                                    </Stack>
                                    <StackItem> <Body1> File Name </Body1> : {downloadFileName} </StackItem>
                                    <StackItem> <Body1> View Devices Under the tenant </Body1> - <Button shape="circular"
                                        appearance="primary" size="small"
                                        onClick={(e) => {
                                            contextValue.setTenantName(siteName); 
                                            localStorage.setItem('tenant', siteName);
                                            setTenant(siteName); // to store it in session-storage

                                            navigate("/manage/devices/overview")
                                        }}> View Devices </Button>
                                    </StackItem>
                                </Stack>
                            </FluentProvider>
                            <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
                        </form>
                    ),
                    "Edit Tenant": (
                        <form id="myFormAppmonitored" onSubmit={handleSubmit}>
                            <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
                                <InfoBar title={"These details will make it easy to find snippet later when you need to use them."} />
                                <Stack tokens={{ childrenGap: 15 }}>
                                    <StackItem>
                                        <Body1Strong> Tenant Name </Body1Strong>
                                    </StackItem>
                                    <StackItem>
                                        <Stack>
                                            <Label size="small" htmlFor={smallId}>
                                            </Label>
                                            <Input size="small" value={formData.tenant} id="0" maxLength={50} disabled={true} />
                                        </Stack>
                                    </StackItem>
                                </Stack>

                                {/* 32-bit Client Executable Dropdown */}
                                <Stack tokens={{ childrenGap: 15 }}>
                                    <StackItem>
                                        <Body1Strong>Windows 32-bit client executable </Body1Strong>
                                    </StackItem>
                                    <StackItem>
                                        <DropdownComponent optionData={dropdownData} setDropDownValue={setDropDownValue} dropDownvalue={dropDownValue} defaultSelected={formData[`client_32_name`]} placeholder="Select Windows 32-bit client executable" required={true} />
                                    </StackItem>
                                </Stack>

                                {/* 64-bit Client Executable Dropdown */}
                                <Stack tokens={{ childrenGap: 15 }}>
                                    <StackItem>
                                        <Body1Strong>Windows 64-bit client executable </Body1Strong>
                                    </StackItem>
                                    <StackItem>
                                        <DropdownComponent optionData={dropDownData64} setDropDownValue={setDropDownValueWin64} dropDownvalue={dropDownValueWin64} defaultSelected={formData[`client_64_name`]} placeholder="Select Windows 64-bit client executable" required={true} />
                                    </StackItem>
                                </Stack>
                                <Stack tokens={{ childrenGap: 15 }}>
                                    <StackItem>
                                        <Body1Strong>Windows version number </Body1Strong>
                                    </StackItem>
                                    <StackItem>
                                        <MultiselectWithTags onChange={(e: any) => handleUserSearchInput(e, 'windows')} options={dropDownDataWindowsVersion} setSelectedOptions={setDropDownValueWindowsVersion} selectedOptions={[dropDownValueWindowsVersion]} multi={false} tag={true} placeholder="Select Windows client version" />
                                    </StackItem>
                                </Stack>

                                {/* Android Client APK Dropdown */}
                                <Stack tokens={{ childrenGap: 15 }}>
                                    <StackItem>
                                        <Body1Strong>Android client APK </Body1Strong>
                                    </StackItem>
                                    <StackItem>
                                        <DropdownComponent optionData={dropDownDataAndroidApk} setDropDownValue={setDropDownValueAndroidApk} dropDownvalue={dropDownValueAndroidApk} placeholder="Select Android client APK" defaultSelected={formData.androidClient} required={false} />

                                    </StackItem>
                                </Stack>
                                <Stack tokens={{ childrenGap: 15 }}>
                                    <StackItem>
                                        <Body1Strong>Android version number </Body1Strong>
                                    </StackItem>
                                    <StackItem>
                                        <MultiselectWithTags onChange={(e: any) => handleUserSearchInput(e, 'android')} options={dropDownDataAndroidVersion} setSelectedOptions={setDropDownValueAndroidVersion} selectedOptions={[dropDownValueAndroidVersion]} multi={false} tag={true} placeholder="Select Android client version" />
                                    </StackItem>
                                </Stack>

                                {/* MAC Versions Dropdown */}
                                <Stack tokens={{ childrenGap: 15 }}>
                                    <StackItem>
                                        <Body1Strong>MAC (M1, M2, M3) </Body1Strong>
                                    </StackItem>
                                    <StackItem>
                                        <DropdownComponent optionData={dropDownDataMacVersion} setDropDownValue={setDropDownValueMACVersion} dropDownvalue={dropDownValueMACVersion} placeholder="Select MAC version" defaultSelected={formData.macVersion} required={false} />
                                    </StackItem>
                                </Stack>

                                {/* MAC Intel Dropdown */}
                                <Stack tokens={{ childrenGap: 15 }}>
                                    <StackItem>
                                        <Body1Strong>MAC (Intel) </Body1Strong>
                                    </StackItem>
                                    <StackItem>
                                        {/* <Dropdown placeholder="Select MAC (Intel)" /> */}
                                        <DropdownComponent optionData={dropDownDataMacIntel} setDropDownValue={setDropDownValueMACIntel} dropDownvalue={dropDownValueMACIntel} placeholder="Select MAC (Intel)" defaultSelected={formData.macIntel} required={false} />
                                    </StackItem>
                                </Stack>
                                <Stack tokens={{ childrenGap: 15 }}>
                                    <StackItem>
                                        <Body1Strong>MAC version number</Body1Strong>
                                    </StackItem>
                                    <StackItem>
                                        <MultiselectWithTags onChange={(e: any) => handleUserSearchInput(e, 'ios')} options={dropDownDataIosVersion} setSelectedOptions={setDropDownValueIosVersion} selectedOptions={[dropDownValueIosVersion]} multi={false} tag={true} placeholder="Select MAC client version" />
                                    </StackItem>
                                </Stack>
                            </Stack>
                            <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
                        </form>
                    ),

                    "Review Data": (
                        <Stack tokens={{ childrenGap: 15, padding: 10 }}>
                            <InfoBar title={"These details will make it easy to find snippet later when you need to use them."} />
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong> Tenant Name </Body1Strong>
                                </StackItem>
                                <StackItem>
                                    <Stack>
                                        <Label size="small" htmlFor={smallId}>
                                        </Label>
                                        <Input size="small" value={formData.tenant} id="0" maxLength={50} disabled={true} />
                                    </Stack>
                                </StackItem>
                            </Stack>

                            {/* 32-bit Client Executable Dropdown */}
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong>Windows 32-bit client executable </Body1Strong>
                                </StackItem>
                                <StackItem>
                                    {formData[`client_32_name`]?.length > 0 ? <Badge color="informative">{formData[`client_32_name`]}</Badge> : 'Not Selected'}
                                </StackItem>
                            </Stack>

                            {/* 64-bit Client Executable Dropdown */}
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong>Windows 64-bit client executable </Body1Strong>
                                </StackItem>
                                <StackItem>
                                    {formData[`client_64_name`]?.length > 0 ? <Badge color="informative">{formData[`client_64_name`]}</Badge> : 'Not Selected'}
                                </StackItem>
                            </Stack>
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong>Windows version number </Body1Strong>
                                </StackItem>
                                <StackItem>
                                    {formData.windowsVersion?.length > 0 ? <Badge color="informative">{formData.windowsVersion}</Badge> : 'Not Selected'}
                                </StackItem>
                            </Stack>

                            {/* Android Client APK Dropdown */}
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong>Android client APK </Body1Strong>
                                </StackItem>
                                <StackItem>
                                    {formData?.androidClient?.length > 0 ? <Badge color="informative">{formData.androidClient}</Badge> : 'Not Selected'}
                                </StackItem>
                            </Stack>
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong>Android version number </Body1Strong>
                                </StackItem>
                                <StackItem>
                                    {formData.androidVersion?.length > 0 ? <Badge color="informative">{formData.androidVersion}</Badge> : 'Not Selected'}
                                </StackItem>
                            </Stack>

                            {/* MAC Versions Dropdown */}
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong>MAC (M1, M2, M3) </Body1Strong>
                                </StackItem>
                                <StackItem>
                                    {formData?.macVersion?.length > 0 ? <Badge color="informative">{formData.macVersion}</Badge> : 'Not Selected'}
                                </StackItem>
                            </Stack>

                            {/* MAC Intel Dropdown */}
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong>MAC (Intel) </Body1Strong>
                                </StackItem>
                                <StackItem>
                                    {formData?.macIntel?.length > 0 ? <Badge color="informative">{formData.macIntel}</Badge> : 'Not Selected'}
                                </StackItem>
                            </Stack>
                            <Stack tokens={{ childrenGap: 15 }}>
                                <StackItem>
                                    <Body1Strong>MAC version number</Body1Strong>
                                </StackItem>
                                <StackItem>
                                    {formData.iosVersion?.length > 0 ? <Badge color="informative">{formData.iosVersion}</Badge> : 'Not Selected'}
                                </StackItem>
                            </Stack>
                        </Stack>
                    ),
                },
            });
        }
    }, [overlayName, selectedTenant, formData, licenseDetails, downloadURL, downloadFileName, copied, dropDownDataWindowsVersion, dropDownDataAndroidVersion, dropDownDataIosVersion, spinnerLoad]);
    //overlay code ends here
    return (
        <>
            <FullScreen handle={handle} className="fullScreenBackgroundColor">
                <StackItem grow shrink style={BreadcrumbsBorder}>
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem grow shrink>
                            <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                                <StackItem><Text></Text></StackItem>
                                <StackItem grow shrink>
                                    <Breadcrumbs
                                        items={[
                                            {name:"Manage", link:"/home" },
                                            {name:"Administration", link:"/manage/administration/role"},
                                            {name:"Tenant", link:"#"}
                                        ]} 
                                    /> 
                                </StackItem>
                            </Stack>
                        </StackItem>
                    </Stack>
                </StackItem>
                <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
                    <StackItem style={DynamicBoxingCSS}>
                        {/* pages code starts here */}
                        <Stack style={DynamicBoxingCSS}>
                            <FluentProvider style={parentHome} theme={dashboardTheme}>
                                <Stack style={parentHome} horizontal>
                                    {/* SPACING BETWEEN INLINE AND PAGE */}
                                    <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={AdministrationPages("Tenant")} />
                                    <StackItem style={DynamicBoxingCSS}>
                                        <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                                            <StackItem>
                                                <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                                                <Divider />
                                            </StackItem>
                                            <StackItem>
                                                <StackItem style={wraperStyle}>
                                                    <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                                                        <Stack horizontal tokens={{ childrenGap: 10 }}>
                                                        <StackItem>
                                                            <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"Tenant"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                                                            </StackItem>
                                                            <StackItem>
                                                                <MenuDropdown open={filterMenuOpen} btn=
                                                                    {
                                                                        <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                                {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                                                                <Body1> Filter </Body1>
                                                                            </Stack>
                                                                        </MenuButton>
                                                                    } itemVal={
                                                                        <>
                                                                            <Body1Strong> Add a Filter </Body1Strong>
                                                                            <Divider />
                                                                            <MenuList>
                                                                                <Stack tokens={{ childrenGap: 5 }}>
                                                                                    <StackItem> <Text></Text> </StackItem>
                                                                                    <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                                                                    <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                                                                    <StackItem> <Divider /> </StackItem>
                                                                                    <StackItem> <Caption1> Value </Caption1> </StackItem>
                                                                                    {(dropDownValue1 === 'Created On' || dropDownValue1 === 'Modified On') && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />))}
                                                                                    {(dropDownValue1 === "Tenant Name") && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<Input size="small" onChange={inputChange} name="filter" value={dropDownValue2} />))}
                                                                                    {dropDownValue1 === "Created By" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={isCreatedBy} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                                                                    <StackItem> <Divider /> </StackItem>
                                                                                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                                                        <StackItem>
                                                                                            <Button shape="circular"
                                                                                                appearance="primary"
                                                                                                onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                                                                                disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`))}
                                                                                            >  <Caption1> Apply </Caption1> </Button>
                                                                                        </StackItem>

                                                                                        <StackItem>
                                                                                            <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                                                                                <Caption1> Cancel </Caption1>
                                                                                            </Button>
                                                                                        </StackItem>
                                                                                    </Stack>
                                                                                </Stack>
                                                                            </MenuList>
                                                                        </>
                                                                    }
                                                                />
                                                            </StackItem>
                                                            <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                                                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                        <StackItem> <FilterDismiss20Filled /> </StackItem>
                                                                        <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                                                    </Stack>
                                                                </Button>
                                                            </StackItem>
                                                        </Stack>
                                                        {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                                                    </Stack>
                                                    <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                                                        <StackItem>
                                                            {filterArray.length > 0 && (
                                                                <Stack horizontal wrap>
                                                                    {filterArray.map((item, index) => (
                                                                        <Button shape="circular" size="small">
                                                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                                <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                                                                <StackItem>
                                                                                    <Stack tokens={{ childrenGap: 1 }}>
                                                                                        <StackItem><Text></Text></StackItem>
                                                                                        <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                                                                    </Stack>
                                                                                </StackItem>
                                                                            </Stack>
                                                                        </Button>
                                                                    ))}
                                                                </Stack>
                                                            )}
                                                        </StackItem>

                                                        <StackItem disableShrink>
                                                            {(tableData.length > 0 && !loading) && (
                                                                totalRecords > 0 &&
                                                                <Caption1>
                                                                    Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                                                </Caption1>
                                                            )}
                                                        </StackItem>
                                                    </Stack>
                                                </StackItem>
                                                <Stack tokens={{ childrenGap: 10 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                            </StackItem>
                                            <Tenant_func
                                                site={siteName}
                                                rowID={rowID}
                                                setRowID={setRowID}
                                                filterArray={filterArray}
                                                data={final_data}
                                                func={set_final_data}
                                                searchVal={searchVal}
                                                pageNo={(currentPageNo - 1) * 50}
                                                setTotalPages={setTotalPages}
                                                setTotalRecords={setTotalRecords}
                                                isFilter={isfilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2}
                                                overlayOpen={overlayOpen}
                                                setRefreshToast={setRefreshToast}
                                                setIsRefresh={setIsRefresh}
                                                refreshToast={refreshToast}
                                                isRefresh={isRefresh}
                                                dropdownData={dropdownData}
                                                setClientList={setClientList}
                                                setClientVersionsList={setClientVersionsList}
                                                formData={formData}
                                                setFormData={setFormData}
                                                overlayName={overlayName}
                                                formEditData={formEditData}
                                                setFormEditData={setFormEditData}
                                                saveBtnClicked={saveBtnClicked}
                                                setErrorToast={setErrorToast}
                                                setToastMessage={setToastMessage}
                                                setSaveBtnClicked={setSaveBtnClicked}
                                                setOverlayName={setOverlayName}
                                                setOverlayOpen={setOverlayOpen}
                                                setIsToast={setIsToast}
                                                setDropDownValueMACIntel={setDropDownValueMACIntel}
                                                setDropDownValueMACVersion={setDropDownValueMACVersion}
                                                setDropDownValueAndroidApk={setDropDownValueAndroidApk}
                                                setDropDownValueWin64={setDropDownValueWin64}
                                                setDropDownValue={setDropDownValue}
                                                setLicenseDetails={setLicenseDetails}
                                                licenseDetails={licenseDetails}
                                                setDownloadURL={setDownloadURL}
                                                setDownloadFileName={setDownloadFileName}
                                                setClientExecutableFiles={setClientExecutableFiles}
                                                exportBtnClicked={exportBtnClicked}
                                                setExportBtnClicked={setExportBtnClicked}
                                                setExportDetails={setExportDetails}
                                                tenant={tenantName}
                                                setDropDownValueWindowsVersion={setDropDownValueWindowsVersion}
                                                setDropDownValueAndroidVersion={setDropDownValueAndroidVersion}
                                                setDropDownValueIosVersion={setDropDownValueIosVersion}
                                                setSpinnerLoad = {setSpinnerLoad}
                                            />
                                            {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                                            {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </FluentProvider>
                        </Stack>
                        <OverLay
                            overlayopen={overlayOpen}
                            setOverlayOpen={setOverlayOpen}
                            overlayData={tenantOverLayData}
                            saveBtnFunc={setSaveBtnClicked}
                            saveBtnClicked={saveBtnClicked}
                            isNavBtn={true}
                            handleOutsideButton={handleOutsideButton}
                            handleSubmit={handleSubmit}
                        />
                    </StackItem>
                    <StackItem><Text></Text></StackItem>

                    {/* {overlayName === 'editTenant' && saveBtnClicked && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={"Tenant Details Updated Successfully"} footer="" />} */}

                    {isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={overlayName === 'addTenant' ? "New Tenant Created Successfully" : "Tenant Details Updated Successfully"} footer="" />}

                    {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}

                    {errorToast && (<ToastComponent setmessagebar={setErrorToast} toastIntent="error" position="top-end" title="Failed" message={toastMessage} footer="" />)}

                    {isDynamicToast && (
                        <ToastComponent setmessagebar={setIsToast} isToastEnabled={isDynamicToast} toastIntent={message.type} position="top-end" title={message.type.charAt(0).toUpperCase() + message.type.slice(1)} message={message.text} footer="" />
                    )}
                </Stack>
            </FullScreen>
        </>
    );
};
